/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateMultipleTimeRegsInput = {|
  taskId?: ?string,
  idleTimeId?: ?string,
  projectId?: ?string,
  year?: ?number,
  month?: ?number,
  day?: ?number,
  endYear?: ?number,
  endMonth?: ?number,
  endDay?: ?number,
  minutesRegistered?: ?number,
  harvestTaskId?: ?string,
  unit4ActivityId?: ?string,
  unit4ActivityName?: ?string,
  personId?: ?string,
  billable?: ?boolean,
  notes?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createMultipleTimeRegistrationMutationVariables = {|
  input: CreateMultipleTimeRegsInput
|};
export type createMultipleTimeRegistrationMutationResponse = {|
  +createMultipleTimeRegs: ?{|
    +errors: ?$ReadOnlyArray<?string>
  |}
|};
export type createMultipleTimeRegistrationMutation = {|
  variables: createMultipleTimeRegistrationMutationVariables,
  response: createMultipleTimeRegistrationMutationResponse,
|};
*/


/*
mutation createMultipleTimeRegistrationMutation(
  $input: CreateMultipleTimeRegsInput!
) {
  createMultipleTimeRegs(input: $input) {
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMultipleTimeRegsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMultipleTimeRegsPayload",
    "kind": "LinkedField",
    "name": "createMultipleTimeRegs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMultipleTimeRegistrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMultipleTimeRegistrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createMultipleTimeRegistrationMutation",
    "operationKind": "mutation",
    "text": "mutation createMultipleTimeRegistrationMutation(\n  $input: CreateMultipleTimeRegsInput!\n) {\n  createMultipleTimeRegs(input: $input) {\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b9d9f056f5b74bdbc01f5c602a9e46d4';

module.exports = node;
